import React from "react"
import Layout from "../components/Layout"
import "../css/projects/web-project/web_proj1.css"
import { Link } from "gatsby"
import { FaCode, FaLink } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const ml_proj3 = () => {
  return (
    <Layout>
      <SEO
        title="Restotante Con Fusion"
        description="Full Fledged Awesome Website Development (Web-Dev) project"
      />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/ml_project/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="mlproj-img3"> 
          <div className="py-1-heading">
            <h1>Movie Recommendation Web-App</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Movie-Recommendation-Web-App"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>
        <div className="git">
          <a
            href="https://movie-recommendation-system-ap.herokuapp.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="View live"
          >
            <FaLink className="git-btn"></FaLink>
          </a>
        </div>
        
        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It:</h3>
            <p>
              It is a end to end machine learning project
              <br/>
              <br />Model is made on movie dataset which include useful information like Movie Title, Genres etc.
               
              <br />
              Starting with pre-processeing of data.
              <br/><br/>
              
              Finally taking csv file of our model for later use in Flask. 
               <br/>
              <br/>
              Initialise Flask app, and setting required function's connected with our model.
              <br/> 
              Used good looking template with fine css for our page.
              <br /> <br/>
              Finally deployed on Heroku.
              <br />
            </p>

            <h3>Skills Behind It:</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Pandas</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Numpy</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Flask</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>HTML</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>CSS</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Heroku</span>
              </button>

            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default ml_proj3
